"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'HintText',
    props: {
        hintText: {},
        disabled: { type: Boolean },
        noIndent: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["pt-1 text-xs", [_ctx.disabled ? 'text-gray-50' : 'text-gray-80', { 'pl-4': !_ctx.noIndent }]])
            }, (0, vue_2.toDisplayString)(_ctx.hintText), 3));
        };
    }
});
